export default {
  'CALL_ACTION' (state) {
    return state.call_action
  }
}
